import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { useConfig } from '../../config/ContentComponentLibraryProvider';
import Sources from '../../components/Image/Sources';
import styles from './index.module.scss';
const getImageUrl = (fileReference, scene7Url, domain) => {
    if (scene7Url)
        return scene7Url;
    if (fileReference)
        return `${domain}${fileReference}`;
    return null;
};
const Picture = ({ altText, fileReference, hasFixedHeight, height, width, scene7Url, scene7UrlMobile, mobileHeight, mobileWidth, scene7UrlTablet, tabletHeight, tabletWidth, sizes, preload = false, }) => {
    const config = useConfig();
    const imageUrl = getImageUrl(fileReference, scene7Url || scene7UrlTablet || scene7UrlMobile, config.cfDomain);
    if (!imageUrl)
        return null;
    return (React.createElement("picture", null,
        React.createElement(Sources, { scene7Url: scene7UrlMobile, breakpoint: "mobile", sizes: sizes, height: mobileHeight, width: mobileWidth, preload: preload }),
        React.createElement(Sources, { scene7Url: scene7UrlTablet, breakpoint: "tablet", sizes: sizes, height: tabletHeight, width: tabletWidth, preload: preload }),
        React.createElement(Sources, { scene7Url: scene7Url, sizes: sizes, height: height, width: width, preload: preload }),
        React.createElement("img", { className: classNames(styles.image, {
                [styles.fixedHeight]: hasFixedHeight,
            }), alt: altText, loading: preload ? undefined : 'lazy', fetchpriority: preload ? 'high' : undefined, src: imageUrl, height: height, width: width })));
};
Picture.displayName = 'Picture';
Picture.propTypes = {
    altText: propTypes.string,
    fileReference: propTypes.string,
    hasFixedHeight: propTypes.bool,
    height: propTypes.string,
    scene7Url: propTypes.string,
    scene7UrlMobile: propTypes.string,
    mobileHeight: propTypes.string,
    mobileWidth: propTypes.string,
    scene7UrlTablet: propTypes.string,
    tabletHeight: propTypes.string,
    tabletWidth: propTypes.string,
    sizes: propTypes.string,
    width: propTypes.string,
    preload: propTypes.bool,
};
export default Picture;
//# sourceMappingURL=Picture.js.map